/** @format */
import { css } from 'styled-components';

/**
 * Base styles for the article results component
 */
const baseStyles = css``;

/**
 * The article results component styles
 */
export const styles = css`
    ${baseStyles}
`;
